import type {
  AutocompleteField as AutocompleteFieldType,
  FormOption,
  SelectField as SelectFieldType,
} from '@/screens/ReportCreation/reportCreation.types';
import {
  normalizeDependencyName,
  type DependencyValue,
} from './conditionalVisibility.utils';

export const resolveDynamicOptions = (
  field: SelectFieldType | AutocompleteFieldType,
  dependencyValueMap: Record<string, DependencyValue>,
): FormOption[] => {
  if (!field.dynamicOptions) {
    return field.options;
  }

  const dependencyName = normalizeDependencyName(
    field.dynamicOptions.dependsOn,
  );
  const dependencyValue = dependencyValueMap[dependencyName];
  if (typeof dependencyValue !== 'string') {
    return [];
  }

  return field.dynamicOptions.optionsByValue[dependencyValue] ?? [];
};
